import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { ContentCoverImage } from "scmp-app/components/content/content-cover-image";
import { ContentItemHomeSecondaryV2 } from "scmp-app/components/content/content-item-render/variants/home-secondary-v2";
import {
  ActionBar as SecondaryActionBar,
  Headline as SecondaryHeadline,
  Summary as SecondarySummary,
} from "scmp-app/components/content/content-item-render/variants/home-secondary-v2/styles";
import { SectionLink } from "scmp-app/components/content/content-sections/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    padding-block: 0;
  }
`;

export const HeaderBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ArticleOneRow = styled.div`
  display: grid;
  grid:
    "primary-text" min-content
    "primary-image" min-content
    "secondary" min-content
    / 100%;

  ${theme.breakpoints.up("tablet")} {
    grid:
      "primary-text primary-image" min-content
      "secondary primary-image" min-content
      ". primary-image" min-content
      / 0.5fr 0.5fr;
    column-gap: 20px;
  }

  ${theme.breakpoints.up("desktop")} {
    grid-template-columns: minmax(220px, 332px) minmax(386px, 550px);
  }
`;

export const PrimaryText = styled.div`
  grid-area: primary-text;
`;

export const HeroImageLink = styled(EntityLink)`
  grid-area: primary-image;

  display: block;

  inline-size: 100%;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }

  ${theme.breakpoints.up("tablet")} {
    align-self: start;

    max-inline-size: 550px;
  }
`;

export const StyedContentCoverImage = styled(ContentCoverImage)``;

export const SecondaryText = styled.div`
  grid-area: secondary;

  margin-block-start: 16px;
  padding-block-start: 16px;
  border-block-start: 1px solid #dfdfdf;
`;

export const FullDivider = styled.div`
  block-size: 1px;

  background-color: #dfdfdf;
`;

export const BottomRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    gap: 20px;
  }
`;

export const BottomItem = styled.div`
  ${theme.breakpoints.up("tablet")} {
    flex: 1 1 0;

    min-inline-size: 0;
  }
`;

export const BottomDivider = styled.div`
  block-size: 1px;

  background-color: #dfdfdf;

  ${theme.breakpoints.up("tablet")} {
    flex: none;
    align-self: stretch;

    inline-size: 1px;
    block-size: auto;
  }
`;

export const StyledPrimaryItem = styled(ContentItemHomeSecondaryV2)`
  ${SectionLink} {
    color: #333333;
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
  }

  ${SecondaryHeadline} {
    font-size: 18px;
    line-height: 120%;
    letter-spacing: -0.36px;

    ${theme.breakpoints.up("tablet")} {
      font-size: 20px;
      letter-spacing: -0.4px;
    }
  }

  ${SecondarySummary} {
    color: #5a5a5a;
    font-size: 14px;
    line-height: 135%;
  }

  ${SecondaryActionBar} time {
    color: #727272;
    font-size: 11px;
  }
`;

export const StyledSecondaryItem = styled(ContentItemHomeSecondaryV2)`
  ${SectionLink} {
    color: #333333;
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
  }

  ${SecondaryHeadline} {
    font-size: 16px;
    line-height: 130%;
    letter-spacing: -0.32px;
  }

  ${SecondaryActionBar} time {
    color: #727272;
    font-size: 11px;
  }
`;
